import { useSelector } from 'react-redux';
import { getUserAccessSelector } from './redux/selector/userSelector';

export const getPermission = ({ module }) => {
  const userAccessSelector = getUserAccessSelector({ module: module });
  const scopes = useSelector(userAccessSelector);
  return scopes;
};

export const getPermissionScope = (scopes, action) => {
  return true;
  // return scopes.includes(action);
};

export const regexOnNumberGraterThanZero = {
  pattern: /^(?!0(\.0+)?$)\d+(\.\d+)?$/,
  message: 'Invalid input. Please enter a number greater than or equal to 1.',
};

export const regexOnNumberGraterThanZeroOrEqualToZero = {
  pattern: /^(0|[1-9]\d*)(\.\d+)?$/,
  message: 'Invalid input. Please enter a number greater than or equal to 0.',
};

export const regexOnNumber = {
  pattern: /^\d+$/,
  message: 'Must be a number',
};

export const regexOnEmail = {
  pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  message: 'Invalid email address. Please enter a valid email.',
};

export const regexOnPhoneNumber = {
  pattern: /^\+?[1-9]\d{1,9}$/,
  message: 'Invalid phone number. Please enter a valid phone number.',
};

export const regexOnZipCode = {
  pattern: /^[0-9]{6}$/,
  message: 'Invalid zipcode. Please enter a valid  6 digit zipcode.',
};

export const quantityValidation = (value) => {
  // This regex accepts numbers from 0, and decimal numbers from 0.01 to 99.99, inclusive
  const regex = /^(0(\.\d{1,2})?|[1-9]\d*(\.\d{1,2})?)$/;
  return regex.test(value);
};
